<div [formGroup]="parentForm">
  <div class="ui-g m-b-0">
    <div class="ui-g-5">
      <label>{{ label | translate }}</label>
    </div>
    <div class="ui-g-7">
      <wsd-extended-input [control]="parentForm.get(controlName)">
        <p-dropdown [options]="contactTypeItems"
                    placeholder="{{ placeholder | translate }}"
                    [formControlName]="controlName"
                    (onChange)="changeDropdownValue()">
        </p-dropdown>
      </wsd-extended-input>
    </div>
  </div>
</div>
